import { SSFlagValue } from '@portal/state/context/StatsigContext/StatsigFlags';
import { sendAnalytics } from './send-analytics';
import { GAEventMapper } from './types';

export type GlobalAnalyticsValues = {
  sendExperimentAssignments?: SSFlagValue[];
};

export const createAnalyticsEvent =
  <T>(mapper: GAEventMapper<T>) =>
  (data?: T & GlobalAnalyticsValues) => {
    const { sendExperimentAssignments = [] } = data ?? {};

    const hasExperimentAssignments =
      sendExperimentAssignments && sendExperimentAssignments.length > 0;

    const finalAnalytics = {
      ...(data && { ...mapper(data) }),
      ...(hasExperimentAssignments && { sendExperimentAssignments })
    };
    sendAnalytics(finalAnalytics);
  };
